<template>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg3 sm6 xs12 v-for="(item,index) in AnalysisBox" :key="index">
            <div class="DashboardInfo-box">
              <span class="DashboardInfo-box-icon" v-bind:style="{ backgroundColor: item.BGColor }"><v-icon color="white" style="font-size: 44px;">{{ item.Icon }}</v-icon></span>
              <div class="DashboardInfo-box-content">
                <span class="DashboardInfo-box-text">{{ item.Title }}</span>
                <span class="DashboardInfo-box-number">{{ item.Count }}</span>
              </div>
            </div>
        </v-flex>
        <v-layout row wrap>
          <v-flex style="width:490px!important;box-shadow: 0px 0px 6px 0px #61616159;margin: 12px;">
              <v-flex style="text-align: center;font-size: 22px;padding: 0px;font-weight: 600;border-bottom: 1px solid lightgray;padding-bottom: 10px;">
                  Payments 
                 <v-select v-on:change="changePayment" :items="items" label="Select View Type" style="width: 46%;display: inline-block;padding: 0px 15px;float: right;"></v-select>
              </v-flex>
              <GChart type="ColumnChart" :data="GetPaymentData" :options="chartOptions"/>
          </v-flex>
          <v-flex style="width:490px!important;box-shadow: 0px 0px 6px 0px #61616159;margin: 12px;">
              <v-flex style="text-align: center;font-size: 22px;padding: 0px;font-weight: 600;border-bottom: 1px solid lightgray;padding-bottom: 10px;">
                New Registrations
                <v-select v-on:change="changeRegistration" :items="items" label="Select View Type" style="width: 46%;display: inline-block;padding: 0px 15px;float: right;"></v-select>
                </v-flex>
              <GChart type="LineChart" :data="GetRegisterData" :options="chartOptions"/>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
</template>
<script>
import { GChart } from 'vue-google-charts'
export default {
      components: {
        GChart
      },
      data(){
        return {
           items : ['Monthly' , 'Daywise'],
           Type_Pay : "Monthly", // Daywise,
           Type_Reg : "Monthly", // Daywise
           AnalysisBox : [ 
             { Icon  : 'payment', BGColor: '#2196f3', Title : 'Payments', Count : 0 },
             { Icon  : 'work',    BGColor: '#c2185b', Title : 'Jobs Applied', Count : 0 },
             { Icon  : 'notifications', BGColor: '#5c6bc0',Title : 'Total Course', Count : 0 },
             { Icon  : 'forum', BGColor: '#00bcd4',Title : 'New Forum', Count : 0 },
             { Icon  : 'person_add',    BGColor: '#009688',Title : 'New Registration', Count : 0 },
             { Icon  : 'duo',          BGColor: '#4caf50', Title : 'Online Applied', Count : 0 },
             { Icon  : 'meeting_room', BGColor: '#795548', Title : 'Classroom Applied', Count : 0 },
             { Icon  : 'computer',     BGColor: '#ff9800', Title : 'Self Paced Applied', Count : 0 },
           ],
           PaymentMonthData: [ ['Month', 'Payments' ] ],
           RegistrationMonthData: [ ['Month', 'New Registration' ] ],
           PaymentDayData: [ ['Day', 'Payments' ] ],
           RegistrationDayData: [ ['Day', 'New Registration' ] ],
           chartOptions: {
              height : 210,
              width  : 470,
            }
        }
      },
      computed:{
          GetPaymentData(){

              return this.Type_Pay == 'Monthly' ? this.PaymentMonthData : this.PaymentDayData
          },
          GetRegisterData(){

            return this.Type_Reg == 'Monthly' ? this.RegistrationMonthData : this.RegistrationDayData

          }
      },
      methods:{
          changePayment(Type){
              this.Type_Pay = Type
          },
          changeRegistration(Type){
              this.Type_Reg = Type
          }
      },
      mounted(){
         
         this.$http.post(`${this.$store.getters.GetProductionUrl}/analysis/getanalyseddata`)
                  .then(response => {
                        
                        this.$eventHub.$emit("LOADING",'false')
                        if(response['data']['response']){
                  
                          this.AnalysisBox[0]['Count'] = response['data']['response']['Payment']
                          this.AnalysisBox[1]['Count'] = response['data']['response']['Jobs_Applied']
                          this.AnalysisBox[2]['Count'] = response['data']['response']['Total_Course']
                          this.AnalysisBox[3]['Count'] = response['data']['response']['New_Forum']
                          this.AnalysisBox[4]['Count'] = response['data']['response']['New_Registration']
                          this.AnalysisBox[5]['Count'] = response['data']['response']['Webinar']
                          this.AnalysisBox[6]['Count'] = response['data']['response']['Classroom']
                          this.AnalysisBox[7]['Count'] = response['data']['response']['Online']
                          let PaymentMonth      = response['data']['response']['MapData'].find(x => x['Type'] == 'Payment' && x['Duration'] == 'Monthly')['Filtered']
                          let RegistrationMonth = response['data']['response']['MapData'].find(x => x['Type'] == 'Registration' && x['Duration'] == 'Monthly')['Filtered']
                          this.PaymentMonthData = this.PaymentMonthData.concat(PaymentMonth)
                          this.RegistrationMonthData = this.RegistrationMonthData.concat(RegistrationMonth)
                          let PaymentDay      = response['data']['response']['MapData'].find(x => x['Type'] == 'Payment' && x['Duration'] == 'Daywise')['Filtered']
                          let RegistrationDay = response['data']['response']['MapData'].find(x => x['Type'] == 'Registration' && x['Duration'] == 'Daywise')['Filtered']
                          this.PaymentDayData = this.PaymentDayData.concat(PaymentDay)
                          this.RegistrationDayData = this.RegistrationDayData.concat(RegistrationDay)

                        }else{

                            this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Fetching Data", Color: "red",Close: false});
                        }

                  })  
                  .catch(err => {
        
                      this.$eventHub.$emit("LOADING",'false')
                      this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Fetching Data", Color: "red",Close: false});
                  
                  });
      }
}
</script>
<style scoped>
.DashboardInfo-box {
    box-shadow: 0px 0px 6px 0px #61616159;
    border-radius: .25rem;
    padding: .5rem;
    background: #fff;
    display: flex;
}
.DashboardInfo-box-icon {
    border-radius: .25rem;
    display: block;
    width: 84px;
    text-align: center;
    padding: 5px;
    height: 74px;
    display: grid;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    color: white;
    margin: auto;
}
.DashboardInfo-box-content {
    padding: 5px 10px;
    flex: 1;
    text-align: center;
}
.DashboardInfo-box-text {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: 500;
}
.DashboardInfo-box-number{
    font-size: 18px;
    font-weight: bold;
    color: rgb(95, 95, 95);
}
</style>